import { Component } from 'react';
import { object } from 'prop-types';
import { logger } from '@fiverr-private/obs';

class ErrorBoundary extends Component<{}, { hasError: boolean }> {
    static getDerivedStateFromError() {
        return {
            hasError: true,
        };
    }

    constructor(props) {
        super(props);

        this.state = {
            hasError: false,
        };
    }

    override componentDidCatch(error: any) {
        logger.error(error);
    }

    override render() {
        const { hasError } = this.state;

        if (hasError) {
            return null;
        }

        return this.props.children;
    }
}

(ErrorBoundary as any).propTypes = {
    children: object,
};

export default ErrorBoundary;
